import ReactiveDao from "reactive-dao"
import ReactiveSockJS from "reactive-dao-sockjs"
import Vue from 'vue'

window.rd = ReactiveDao

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4()
}

let sessionId = localStorage.sessionId
if(!sessionId) {
  sessionId = guid()
  localStorage.sessionId = sessionId
}

let api =  new ReactiveDao(sessionId, {

  remoteUrl: document.location.protocol + '//' + document.location.host + "/sockjs",

  protocols: {
    'sockjs': ReactiveSockJS
  },

  emailPassword: {
    type: "remote",
    generator: ReactiveDao.ObservableValue
  },
  session: {
    type: "remote",
    generator: ReactiveDao.ObservableValue
  },
  userAdmin: {
    type: "remote",
    generator: (value, what) => {
      console.log("REQUEST GENERATOR",what)
      if(what[0] == 'userAdmin' && what[1] == 'usersList') return new ReactiveDao.ObservableList(value)
      return new ReactiveDao.ObservableValue(value)
    }
  },
  subscription: {
    type: "remote",
    generator: ReactiveDao.ObservableValue
  },
  logs: {
    type: "remote",
    generator: ReactiveDao.ObservableList
  },
  config: {
    type: "remote",
    generator: ReactiveDao.ObservableList
  }


})

api.session = new Vue({
  data: {
    session : null
  },
  computed: {
    loggedIn() {
      return this.session && !!this.session.userId
    },
    roles() {
      return (this.session && this.session.roles) || []
    }
  },
  watch: {
    session(sess) {
      document.querySelector("#preconnect").style.display = sess != null ? "none" : "flex"
    }
  },
  created() {
    api.observable(["session","currentSession"]).bindProperty(this, 'session')
  }
})

export default api



// WEBPACK FOOTER //
// ./src/api/index.js